import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ProgressBar } from "components/molecules";
import { InputControl } from "components/organism";
import { Button } from "components/atoms";
import { useOnBoarding } from "_hooks";
import { useOnBoardingGs1 } from "partner/_hooks";
import companyDataSchema from "partner/Gs1/formSchemas/companyData.schema";
import { useCallback, useEffect, useRef } from "react";

const prefix = "vv-company-data";

const CompanyData = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { fetchSalesChannels } = useOnBoarding();
  const { logoutAuth0, lookAndFeel, resetEnrollmentStep, sendCompanyData } = useOnBoardingGs1();
  const { partner } = useParams();
  const initialized = useRef();
  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(companyDataSchema),
    defaultValues: {
      gln: state?.gln
    }
  });
  
  const { isLoading } = useSelector((s) => s.partner?.[partner]?.enrollmentStepGs1);

  const onSubmit = (data) => sendCompanyData(state?._id, data)
    .then((d) => {
      if (d?.data) {
        navigate(`/partner/${partner}/salesChannels`, { state });
      }
    }
  );
  const checkIt = useCallback(() => {
    if (!initialized?.current) {
      initialized.current = true;
      if (!state?.token || !state?._id || !state?.email) {
        logoutAuth0(partner);
        navigate(`/partner/${partner}/auth0`);
      } else {
        fetchSalesChannels();
      }
    }
  }, [logoutAuth0, navigate, partner, state, fetchSalesChannels]);

  useEffect(() => {
    return () => resetEnrollmentStep();
  }, []);// eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    checkIt();
  }, [checkIt]);

  return (
    <div className={prefix}>
      <div className="mb-5">
        <ProgressBar
          progress={3} max={5} 
          color={lookAndFeel?.progressbar}
        />
      </div>
      <div className="flex flex-wrap flex-col gap-5">
        <p className="text-center text-3xl font-bold mx-auto pb-5">Datos de la empresa</p>

        <form 
          className="flex flex-wrap flex-col gap-10"
          onSubmit={handleSubmit(onSubmit)}
        >
          <InputControl
            errors={errors?.enterpriseName}
            label="Nombre de la empresa"
            orientation="vertical"
            inputProps={{
              autoComplete: "off",
              placeholder: "Ej. ACME",
              ...register("enterpriseName")}
            }
          />

          <InputControl
            errors={errors?.gln}
            label="GLN"
            orientation="vertical"
            inputProps={{
              autoComplete: "off",
              placeholder: "Ej. 7508006406961",
              readOnly: true,
              ...register("gln")}
            }
          />

          <Button
            className="text-white rounded-lg"
            disabled={isLoading}
            style={{
              backgroundColor: lookAndFeel?.primary?.solid,
              color: lookAndFeel?.primary?.text
            }}
            fullwidth
            pulse
            spin={isLoading}
            type="submit"
          >Continuar</Button>
        </form>
      </div>
    </div>
  );
};

export default CompanyData;
